// Theme Mixin Profesional para componentes Vue
import themeManager from '@/store/theme'

export const themeMixin = {
  computed: {
    // Compatibilidad con el sistema anterior
    themeClass() {
      return themeManager.themeClass
    },
    isDarkMode() {
      return themeManager.isDarkMode
    },
    
    // === NUEVO SISTEMA DE CLASES PROFESIONALES ===
    themeClasses() {
      return {
        // === CONTENEDORES PRINCIPALES ===
        pageContainer: 'theme-page-container',
        
        // === COMPONENTES DE TARJETAS ===
        card: 'theme-card',
        cardHeader: 'theme-card-header',
        cardBody: 'theme-card-body',
        cardFooter: 'theme-card-footer',
        cardTitle: 'theme-heading-text',
        cardText: 'theme-secondary-text',
        
        // === TIPOGRAFÍA PROFESIONAL ===
        headingText: 'theme-heading-text',
        primaryText: 'theme-primary-text',
        secondaryText: 'theme-secondary-text',
        mutedText: 'theme-muted-text',
        label: 'theme-label',
        
        // === BOTONES PROFESIONALES ===
        buttonPrimary: 'btn theme-button-primary',
        buttonSecondary: 'btn theme-button-secondary',
        buttonSuccess: 'btn theme-button-success',
        buttonDanger: 'btn btn-danger',
        buttonWarning: 'btn btn-warning',
        buttonInfo: 'btn btn-info',
        buttonLight: 'btn btn-light',
        buttonDark: 'btn btn-dark',
        buttonOutlinePrimary: 'btn btn-outline-primary',
        buttonOutlineSecondary: 'btn btn-outline-secondary',
        buttonOutlineSuccess: 'btn btn-outline-success',
        buttonOutlineDanger: 'btn btn-outline-danger',
        buttonOutlineWarning: 'btn btn-outline-warning',
        buttonOutlineInfo: 'btn theme-button-outline-info',
        
        // === FORMULARIOS ===
        formControl: 'form-control theme-form-control',
        formSelect: 'form-select theme-form-control',
        inputGroup: 'input-group theme-input-group',
        inputGroupText: 'input-group-text theme-input-group-text',
        
        // === NAVEGACIÓN ===
        navTabs: 'nav nav-tabs theme-nav-tabs',
        navLink: 'nav-link theme-nav-link',
        
        // === ALERTAS PROFESIONALES ===
        alertPrimary: 'alert alert-primary',
        alertSecondary: 'alert alert-secondary', 
        alertSuccess: 'alert theme-alert-success',
        alertDanger: 'alert theme-alert-danger',
        alertWarning: 'alert theme-alert-warning',
        alertInfo: 'alert theme-alert-info',
        alertLight: 'alert alert-light',
        alertDark: 'alert alert-dark',
        
        // === SPINNERS ===
        spinner: 'spinner-border theme-spinner',
        
        // === MODALES ===
        modalContent: 'modal-content theme-modal-content',
        modalHeader: 'modal-header theme-modal-header',
        modalBody: 'modal-body theme-modal-body',
        modalTitle: 'modal-title theme-modal-title',
        btnClose: 'btn-close theme-btn-close',
        
        // === TABLAS ===
        table: 'table theme-table',
        tableStriped: 'table table-striped theme-table theme-table-striped',
        tableBordered: 'table table-bordered theme-table',
        tableHover: 'table table-hover theme-table theme-table-hover',
        
        // === LAYOUT ESPECÍFICO ===
        pageHeader: 'theme-page-header',
        pageTitle: 'theme-page-title',
        pageSubtitle: 'theme-page-subtitle',
        filtersSection: 'theme-filters-section',
        searchBox: 'theme-search-box',
        searchInput: 'form-control theme-search-input',
        
        // === UTILIDADES ADICIONALES ===
        loadingShimmer: 'loading-shimmer',
        animateFadeIn: 'animate-fade-in',
        animateFadeInUp: 'animate-fade-in-up',
        animatePulse: 'animate-pulse',
        
        // === BADGES Y ESTADOS ===
        badgePrimary: 'badge bg-primary',
        badgeSuccess: 'badge bg-success',
        badgeWarning: 'badge bg-warning',
        badgeDanger: 'badge bg-danger',
        badgeInfo: 'badge bg-info',
        
        // === CONTENEDORES ESPECIALES ===
        statsCard: 'theme-card p-4 text-center',
        actionCard: 'theme-card p-3 border-0 shadow-sm',
        infoPanel: 'theme-card border-start border-4 border-primary',
        warningPanel: 'theme-card border-start border-4 border-warning',
        successPanel: 'theme-card border-start border-4 border-success'
      }
    }
  }
}

export default themeMixin